import axios from "axios";
import { Base_URL } from "../url";

export const fetchUnits = async () => {
  try {
    const response = await axios.get(`${Base_URL}/UnitMaster/GetAllUnits`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching units!";
  }
};

export const downloadUnitsExcel = async () => {
  try {
    const response = await axios.post(
      `${Base_URL}/UnitMaster/DownloadUnitsExcel`,
      null, // Empty body for POST request
      {
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    return response;
  } catch (error) {
    throw error.response?.data || "Error downloading units data!";
  }
};